/* @ngInject */
export default function CourseRequestCloneModalInstanceCtrl(

  InstitutionsManager,
  CourseModel,
  $uibModalInstance,
  resolveData,
  AlertMessages,
) {
  const vm = this;

  vm.submit = submit;

  initialize();

  function initialize() {
    vm.oldCourse = resolveData.course;
    vm.course = new CourseModel({ cloneCourseId: vm.oldCourse.id });
    vm.institution = InstitutionsManager.institution;
  }

  function submit() {
    vm.errors = {};
    vm.course.requestClone().then(
      () => {
        AlertMessages.success('COURSES.CLONE.SUCCESS_HEADER', 'COURSES.CLONE.SUCCESS_BODY');
        $uibModalInstance.close();
      },
      () => {
        vm.errors.catalogIdTaken = true;
      },
    );
  }
}
